import { FormControl, FormErrorMessage, forwardRef } from "@chakra-ui/react";
import { FormProvider, useForm } from "react-hook-form";
import { Command } from "../../types/command.types";
import Input from "../inputs/Input";
import { Ref, useImperativeHandle } from "react";

type OrderDiscountFormProps = {
  value: Command;
};

export type OrderDiscountFormHandler = {
  values: () => Pick<Command, "discount">;
};

const OrderDiscountForm = forwardRef(
  ({ value }: OrderDiscountFormProps, ref: Ref<OrderDiscountFormHandler>) => {
    const methods = useForm();

    useImperativeHandle(ref, () => ({
      values: () => {
        const values = methods.getValues();
        return {
          discount: values.discount,
        };
      },
    }));
    return (
      <FormProvider {...methods}>
        <form style={{ marginTop: "32px", marginBottom: "32px" }}>
          <FormControl isInvalid={!!methods.formState.errors.discount}>
            <Input
              id="discount"
              placeholder="Remise"
              defaultValue={value?.discount ?? 0}
              {...methods.register("discount", {
                required: "Ce champ est obligatoire",
              })}
            ></Input>
            <FormErrorMessage>
              <>{methods.formState.errors?.discount?.message}</>
            </FormErrorMessage>
          </FormControl>
        </form>
      </FormProvider>
    );
  }
);

export default OrderDiscountForm;
